import React from 'react'
import { BreadCrumb } from 'primereact/breadcrumb'
import '../menus/menu.scss'
// import { MenuItem } from 'primereact/components/menuitem/MenuItem'
import { MenuItem } from 'primereact/menuitem/menuitem'

const Breadcrumb = (props: {
    pathArray: MenuItem[]
    homeUrl: string
    style?: any
}) => {
    const { pathArray, homeUrl, style } = props

    // menuitem in pathArray must provide 'label' and 'url'
    return (
        <BreadCrumb
            className="wardrobe-breadcrumb"
            model={pathArray}
            home={{ icon: 'pi pi-home', url: homeUrl }}
            style={style}
        />
    )
}

export default Breadcrumb
